//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { BVSamplingProduct } from '@apis/campaign-requests/sampling/products/samplingProductsApiModel';

export const uniqueProductIdValidator = (
  productId: string,
  productsInCampaign: BVSamplingProduct[],
  currentProductId?: string,
) => {
  // Check if the new ID matches any product ID in the campaign, except the one being edited
  const isUniqueInCampaign = productsInCampaign.every((productInCampaign) => {
    // If this is the product being edited (has the same ID as currentProductId),
    // then skip this comparison (return true to continue the every() check)
    if (
      currentProductId &&
      productInCampaign.targetCatalogProductId?.toLowerCase() ===
        currentProductId.toLowerCase()
    ) {
      return true;
    }

    // For all other products, check if the new ID is different
    return (
      productInCampaign.targetCatalogProductId?.toLowerCase() !==
      productId.toLowerCase()
    );
  });

  if (!isUniqueInCampaign) {
    return 'A product with this ID exists in your campaign';
  }

  return true;
};
